export function assert(condition) {
    if (!condition()) {
        var msg = "Assert failed: \"".concat(condition.toString(), "\" must be true, but was not!");
        console.error(msg);
        throw new Error(msg);
    }
}
